var fi = {};
module['exports'] = fi;
fi.title = "Finnish";
fi.name = require("./name");


//////////////////
// WEBPACK FOOTER
// ./node_modules/faker/lib/locales/fi/index.js
// module id = 2947
// module chunks = 1610